<template>
  <div class="PieBase">
    <apexchart
      type=pie
      :options="chartOptions"
      :series="chartSeries"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'PieBase',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Opciones para la grafica */
    chartOptions: {
      type: Array,
      required: true
    },
    /** Datos a graficar */
    chartSeries: {
      type: Array,
      required: true
    }
  },

  components: {
    apexchart: VueApexCharts
  }
}
</script>
